import { MdSpaceDashboard, MdCategory, MdLayers, MdLocalGroceryStore, MdGroup, MdCoPresent, MdManageAccounts, MdStorefront, MdViewModule, MdBugReport, MdMilitaryTech, MdRateReview } from "react-icons/md";
import { FaUsersCog, FaUserShield } from "react-icons/fa";
import {
    MdLocalShipping,
    MdBusiness,
    MdUpgrade,
    MdNotifications,
    MdDescription,
    MdImage,
    MdSchool,
    MdCampaign,
    MdCreditCard,
    MdPerson,
    MdCardGiftcard,
    MdFlag,
    MdChecklist,
    MdReportProblem,
    MdFeedback,
    MdSettings,
    MdSettingsApplications,
    MdSupportAgent,
    MdRestaurant,
    MdSystemUpdate,
    MdInstallMobile,
    MdAppSettingsAlt,
    MdApps
} from "react-icons/md";
import { MdContactSupport } from "react-icons/md";
import { MdShare } from "react-icons/md";



export const ICON_MAP: any = {
    "MdSpaceDashboard": MdSpaceDashboard,//📊 dashboard

    // Roles & Users
    "FaUserShield": FaUserShield,          // Manage roles
    "FaUsersCog": FaUsersCog,              // Admin users

    // Business / Truck
    "MdLocalShipping": MdLocalShipping,              // Truck stop owners
    "fa fa-building": MdBusiness,                // Transport companies

    // Requests
    "MdUpgrade": MdUpgrade,             // Tier upgrade request
    // System
    "MdNotifications": MdNotifications,               // Notifications
    "MdDescription": MdDescription,              // CMS
    "MdImage": MdImage,                       // Banners
    "MdSchool": MdSchool,             // Training
    "MdCampaign": MdCampaign,                 // Campaign
    "MdCreditCard": MdCreditCard,            // Subscription

    // Users & Rewards
    "MdPerson": MdPerson,                    // Drivers
    "MdGroup": MdGroup,                      // Referrals
    "MdCardGiftcard": MdCardGiftcard,                 // Rewards

    // Location & Config
    "MdFlag": MdFlag,                         // Country
    "MdChecklist": MdChecklist,            // Amenities
    "MdRestaurant": MdRestaurant,
    "MdReportProblem": MdReportProblem,  // Reported issues
    "MdCategory": MdCategory,
    "MdFeedback": MdFeedback,                 // Reviews & feedback
    "MdBugReport": MdBugReport,
    "MdMilitaryTech": MdMilitaryTech,

    // Settings
    "fa fa-cogs": MdSettingsApplications,         // Integration hub
    "MdSettings": MdSettings,                      // Settings
    "MdBusiness": MdBusiness,                      // Business settings

    "MdStorefront": MdStorefront,                 // Shop Category , 
    //  "MdCardGiftcard": MdCardGiftcard,             // reward category
    "MdViewModule": MdViewModule,  // site category

    "MdSupportAgent": MdSupportAgent,   // Request Callback
    "MdContactSupport": MdContactSupport,   // App Support
    "MdShare": MdShare,   // Social Media Links
    "MdSystemUpdate": MdSystemUpdate,   // App Version
    "MdRateReview":MdRateReview,   // App Version
    // fallback icon
    "default": MdSpaceDashboard
};
